import React, { useEffect, useRef, useState } from "react";
import AskpriceModule from "@component/askpriceModule/index";
import { addHandler, scrollToPos } from "newcar-ui/output/cjs/utils/tools";
let App = () => {
  const moduleDom = useRef(null);
  // f 值 默认是问答页 1252
  const [f, setF] = useState(1252);
  useEffect(() => {
    // 不同页面可能会引用一个模板，f 取模板全局变量
    const fc = window.askprice_f
    fc && setF(fc)
    const btn = document.getElementById("gotoAskpriceBtn");
    btn &&
      addHandler(btn, "click", function () {
        moduleDom.current.getTop((top) => {
          scrollToPos(0, top);
        });
      });
  }, []);
  return (
    <>
      <AskpriceModule
        f={f}
        lineId={window.lineId || ""}
        lineName={window.lineName || ""}
        ref={moduleDom}
      ></AskpriceModule>
    </>
  );
};

export default App;
